import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { AdresseForm } from '../../genericComponents/AdresseForm/AdresseForm';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { UserService } from '../../../services/UserService';
import { ResponsableService } from '../../../services/ResponsableService';
import { ResponsableForm } from './ResponsableForm';

export interface Props {
    information: ReqType.UserView;
    changeProfile: (e: ReqType.UserView) => void;
}

interface State {
    editable: boolean;
}

/**
 * Ce composant permet l'affichage des informations du profil
 */
export class InfoProfile extends React.Component {
    props: Props;
    state: State;
    backupProfil: ReqType.UserView;

    constructor(props: Props) {
        super(props);
        this.state = {
            editable: false,
        };
    }

    render() {
        return (
            <div className="card card-default">
                <div className="row card-header col-12" style={{ marginLeft: '1px' }}>
                    <div className="col-6">
                        <h4 className="text-white">
                            <strong>Mes Informations</strong>
                        </h4>
                    </div>
                    <div
                        className="col-6"
                        style={{ textAlign: 'right' }}
                    >
                        <button
                            className="btn btn-outline-light"
                            style={{}}
                            onClick={
                                () => {
                                    this.backupProfil = UserService
                                        .getInstance()
                                        .duplicateUserView(this.props.information);
                                    this.setState({ editable: true });
                                }
                            }
                        >
                            <i className="fas fa-edit" />
                        </button>
                    </div>
                </div>

                <div className="card-body">
                    <this.DisplayInformation />
                </div>

                <div className="card-footer" style={this.state.editable ? {} : { display: 'none' }}>
                    <div className="container-fluid justify-content-end" style={{ display: 'flex' }}>
                        <button
                            className="btn btn-outline-danger btn-lg"
                            onClick={
                                () => {
                                    this.props.changeProfile(
                                        JSON.parse(JSON.stringify(this.backupProfil))
                                    );
                                    this.setState({ editable: false });
                                }
                            }

                        >
                            Annuler
                        </button>
                        <LoaderButton
                            className="btn btn-lg"
                            style={{ marginLeft: '20px' }}
                            onClick={
                                () => {
                                    return (this.sendServer().then(
                                        () => {
                                            this.setState({ editable: false });
                                        }
                                    ));
                                }
                            }
                            confirmation={true}
                            modalTitle="Changement des informations du profil"
                            modalBody="Etes vous certain de vouloir changer ces informations ?"
                        >
                            Valider
                        </LoaderButton>
                    </div>
                </div>
            </div>
        );
    }

    private DisplayName() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information.userProfile === null) {
            return undefined;
        } else {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Nom : </strong></label>
                    {this.props.information.userProfile.nom}
                </li>
            );
        }
    }
    private DisplayLastName() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information.userProfile === null) {
            return undefined;
        } else {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong> Prénom : </strong></label>
                    {this.props.information.userProfile.prenom}
                </li>
            );
        }
    }

    private DisplayPhone() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information.userProfile === null) {
            return (undefined);
        } else if (this.state.editable) {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Téléphone : </strong></label>
                    <input
                        className="form-control form-control-lg col-12"
                        placeholder="Téléphone"
                        value={this.props.information.userProfile.telephone}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                if (this.props.information.userProfile !== null) {
                                    var newProfil = UserService.getInstance().duplicateUserView(this.props.information);
                                    newProfil.userProfile!.telephone = e.target.value;
                                    this.props.changeProfile(newProfil);
                                }
                            }
                        }
                        name="phone"
                        type="text"
                    />
                </li >
            );
        } else {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Téléphone :</strong></label>
                    {this.props.information.userProfile.telephone}
                </li>
            );
        }
    }

    private DisplayEmail() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.state.editable) {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Email :</strong></label>
                    <input
                        className="form-control form-control-lg col-12"
                        placeholder="Email"
                        value={this.props.information.email}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newProfil = UserService.getInstance().duplicateUserView(this.props.information);
                                newProfil.email = e.target.value;
                                this.props.changeProfile(newProfil);
                            }
                        }
                        name="email"
                        type="text"
                    />
                </li >
            );
        } else {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Email :</strong></label>
                    {this.props.information.email}
                </li>
            );
        }
    }

    private DisplayMensurations() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information.userProfile === null) {
            return undefined;
        } else if (this.state.editable) {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Taille :</strong></label>
                    <input
                        className="form-control form-control-lg col-6"
                        placeholder="Taille (en centimètres)"
                        value={this.props.information.userProfile.taille}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                if (this.props.information.userProfile !== null) {
                                    var newProfil = UserService.getInstance().duplicateUserView(this.props.information);
                                    newProfil.userProfile!.taille = e.target.value;
                                    this.props.changeProfile(newProfil);
                                }
                            }
                        }
                        name="Height"
                        type="number"
                    />
                    <label style={{ marginRight: '15px' }}><strong>Pointure :</strong></label>
                    <input
                        className="form-control form-control-lg col-6"
                        placeholder="Pointure"
                        value={this.props.information.userProfile.pointure}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                if (this.props.information.userProfile !== null) {
                                    var newProfil = UserService.getInstance().duplicateUserView(this.props.information);
                                    newProfil.userProfile!.pointure = e.target.value;
                                    this.props.changeProfile(newProfil);
                                }
                            }
                        }
                        name="Pointure"
                        type="number"
                    />
                </li>
            );
        } else {
            return (
                <li className={liClass}>
                    <div className="row" style={{ marginLeft: '1px' }}>
                        <label style={{ marginRight: '15px' }}><strong>Taille :</strong></label>
                        <p>{this.props.information.userProfile.taille}</p>
                    </div>
                    <div className="row" style={{ marginLeft: '1px' }}>
                        <label style={{ marginRight: '15px' }}><strong>Pointure :</strong></label>
                        <p>{this.props.information.userProfile.pointure}</p>
                    </div>
                </li>
            );
        }
    }

    private DisplayDateNaissance() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information.userProfile === null) {
            return (undefined);
        } else if (this.state.editable) {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Date de naissance :</strong></label>
                    <input
                        className="form-control form-control-lg col-12"
                        placeholder="Date de naissance"
                        value={this.props.information.userProfile.date_naissance}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                if (this.props.information.userProfile !== null) {
                                    var newProfil = UserService.getInstance().duplicateUserView(this.props.information);
                                    newProfil.userProfile!.date_naissance = e.target.value;
                                    this.props.changeProfile(newProfil);
                                }
                            }
                        }
                        name="birthdate"
                        type="date"
                    />
                </li >
            );
        } else {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Date de naissance :</strong></label>
                    {this.props.information.userProfile.date_naissance}
                </li>
            );
        }
    }

    private DisplayAdresse() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information.userProfile === null) {
            return (undefined);
        } else if (this.state.editable) {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Adresse :</strong></label>
                    <AdresseForm
                        adresse={this.props.information.userProfile.adresse}
                        disabled={false}
                        setAdresse={
                            (adresse: ReqType.Adresse) => {
                                if (this.props.information.userProfile !== null) {
                                    var newProfil = UserService.getInstance().duplicateUserView(this.props.information);
                                    newProfil.userProfile!.adresse = adresse;
                                    this.props.changeProfile(newProfil);
                                }
                            }
                        }
                    />
                </li >
            );
        } else {
            return (
                <li className={liClass}>
                    <label style={{ marginRight: '15px' }}><strong>Adresse :</strong></label>
                    <AdresseForm
                        adresse={this.props.information.userProfile.adresse}
                        disabled={true}
                        setAdresse={
                            (adresse: ReqType.Adresse) => {
                                if (this.props.information.userProfile !== null) {
                                    this.props.information.userProfile.adresse = adresse;
                                    this.props.information.userProfile.adresse.id = -1;
                                    this.props.changeProfile(this.props.information);
                                }
                            }
                        }
                    />
                </li>
            );
        }
    }

    private DisplayResponsable() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information.userProfile === null) {
            return (undefined);
        } else if (this.state.editable) {
            return (
                <li className={liClass}>
                    <div className="form-group">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={this.props.information.userProfile.responsable !== null}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var newProfil =
                                        UserService.getInstance().duplicateUserView(this.props.information);
                                    if (e.target.checked) {
                                        newProfil.userProfile!.responsable =
                                            ResponsableService.getInstance().getDefaultResponsable();
                                        this.props.changeProfile(newProfil);
                                    } else {
                                        newProfil.userProfile!.responsable = null;
                                        this.props.changeProfile(newProfil);
                                    }
                                }
                            }
                        />
                        <label className="form-check-label">
                            {
                                this.props.information.userProfile.responsable === null ?
                                    'Pas de responsable' :
                                    'Avec un responsable'
                            }
                        </label>
                    </div>
                    {this.props.information.userProfile.responsable === null ? undefined :
                        (
                            <ResponsableForm
                                changeResponsable={
                                    (responsable: ReqType.Responsable) => {
                                        var newProfil =
                                            UserService.getInstance().duplicateUserView(this.props.information);
                                        newProfil.userProfile!.responsable = responsable;
                                        this.props.changeProfile(newProfil);
                                    }
                                }
                                editable={true}
                                responsable={this.props.information.userProfile.responsable}
                            />
                        )
                    }
                </li >
            );
        } else if (this.props.information.userProfile.responsable === null) {
            return undefined;
        } else {
            return (
                <li className={liClass}>
                    {this.props.information.userProfile.responsable === null ? undefined :
                        (
                            <ResponsableForm
                                changeResponsable={
                                    (responsable: ReqType.Responsable) => {
                                        return;
                                    }
                                }
                                editable={false}
                                responsable={this.props.information.userProfile.responsable}
                            />
                        )
                    }
                </li>
            );
        }
    }

    // affichage des informations du titulaire du compte.
    private DisplayInformation = () => {
        return (
            <div className="col-12">
                <ul className="list-group">
                    {this.DisplayName()}
                    {this.DisplayLastName()}
                    {this.DisplayPhone()}
                    {this.DisplayEmail()}
                    {this.DisplayMensurations()}
                    {this.DisplayDateNaissance()}
                    {this.DisplayAdresse()}
                    {this.DisplayResponsable()}
                </ul>
            </div>
        );
    }

    // Mise en ligne
    private sendServer(): Promise<void> {
        return (
            UserService.getInstance().editUser(this.props.information, this.backupProfil).then(
                (resp: ReqType.UserView) => {
                    this.props.changeProfile(resp);
                    return;
                }
            ).catch(
                (e) => { alert(JSON.stringify(e)); }
            )
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/InfoProfile.tsx